"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
/**
 * The Statsig SDK context used by the StatsigProvider, and consumed by other SDK helper functions
 */
exports.default = react_1.default.createContext({
    initialized: false,
    statsigPromise: null,
    userVersion: 0,
    initStarted: false,
    updateUser: function () {
        // noop
    },
    hooksMemoKey: null,
});
